import { computed, watch } from 'vue'
import { useSearchStore } from '@/stores/searchStore'
import { useSliderStore } from '@/stores/sliderStore'


export function useSynchronizedSearchSlideBar(id: string) {
  const searchStore = useSearchStore()
  const sliderStore = useSliderStore()
  watch(
    () => searchStore.hasSearchContent,
    (hasContent) => {
      if (hasContent) {
        sliderStore.setSliderState(id, false)
      }
    }, {
      immediate: true,
      flush: 'post',
  })
}
